module.exports = __webpack_public_path__ + "assets/img/btn-view-f0621a91.png";